import { render, staticRenderFns } from "./invalid-enterprise.vue?vue&type=template&id=fbf04a9a"
import script from "./invalid-enterprise.vue?vue&type=script&lang=js"
export * from "./invalid-enterprise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports